export const downloadFromBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob)
  const temporaryLink = document.createElement('a')
  temporaryLink.href = url
  temporaryLink.download = filename
  document.body.appendChild(temporaryLink)
  temporaryLink.click()
  temporaryLink.remove()
  URL.revokeObjectURL(url)
}
